import request from "@/utils/request";
import Qs from "qs";

// 标签列表
export function tagLists(data) {
  return request({
    url: "/tag/lists",
    method: "post",
    // ContentType:'multipart/form-data',
    data: Qs.stringify(data),
  });
}

// 添加标签
export function tagAdd(data) {
  return request({
    url: "/tag/add",
    method: "post",
    // ContentType:'multipart/form-data',
    data: Qs.stringify(data),
  });
}

// 编辑标签
export function tagEdit(data) {
  return request({
    url: "/tag/edit",
    method: "post",
    // ContentType:'multipart/form-data',
    data: Qs.stringify(data),
  });
}

// 标签详情
export function tagInfo(data) {
  return request({
    url: "/tag/info",
    method: "post",
    // ContentType:'multipart/form-data',
    data: Qs.stringify(data),
  });
}

// 删除标签
export function tagDel(data) {
  return request({
    url: "/tag/del",
    method: "post",
    // ContentType:'multipart/form-data',
    data: Qs.stringify(data),
  });
}
